export function detectTimezone() {
  try {
    const tz = Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone;
    return tz || 'UTC';
  } catch {
    return 'UTC';
  }
}

export function persistTimezone(tz) {
  try { localStorage.setItem('pref:timezone', tz); } catch (e) { void e; }
}

export function getPersistedTimezone() {
  try { return localStorage.getItem('pref:timezone') || null; } catch (e) { void e; return null; }
}
